import type { Point2d } from "@logic/lib/2d"
import { scalePixelsToInches } from "@logic/lib/utils"
import { atom, selector, useRecoilTransaction_UNSTABLE } from "recoil"

import { siteLocalState } from "~/containers/Proposal/state/site/site-state"

import type { TransactionOperation } from ".."
import { readonlyTransactors, getMousePositionInStudio } from ".."
import { startPointState } from "../../../inputs"
import { getPreferredImage } from "../getPreferredImage"

export const startDrag: TransactionOperation = (transactors) => {
  const { set } = transactors
  const mouse = getMousePositionInStudio(transactors)
  set(startPointState, mouse)
}

export const finishDrag: TransactionOperation = ({ set }) => {
  set(startPointState, null)
}

export const useDragRuler: () => [VoidFunction, VoidFunction] = () => [
  useRecoilTransaction_UNSTABLE((transactors) => () => startDrag(transactors)),
  useRecoilTransaction_UNSTABLE((transactors) => () => finishDrag(transactors)),
]

export const rulerLengthState = selector<number>({
  key: `rulerLength`,
  get: ({ get }) => {
    const p1 = get(startPointState)
    const p2 = getMousePositionInStudio(readonlyTransactors(get))
    const { latitude } = get(siteLocalState)
    const image = getPreferredImage(readonlyTransactors(get))

    if (!p1 || !p2 || !image) return 0
    const { zoomLevel } = image
    const length = Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2)
    const result = scalePixelsToInches({
      pixels: length,
      latitude,
      zoomLevel,
    })

    const lengthScaled = result

    return lengthScaled
  },
})
